import { PlanMode, PlanTypes } from 'mbs-ui-shared@models/PlanTypes.enum';
import { BaseForStepsHelper, WizardHelpersSettings } from 'wizards/helpers/bases/base-for-steps-helper';
import { RestoreStepsDataFromPlanHelper } from 'wizards/helpers/restore-steps-data-from-plan-helper/restore-steps-data-from-plan-helper';
import { StepsDataFromPlanHelper } from 'wizards/helpers/steps-data-from-plan-helper/steps-data-from-plan-helper';
import { SupportMethodsForStepsFromPlan } from 'wizards/helpers/support-methods-for-steps-from-plan';
import { RestoreVMFormModel } from 'wizards/models/base/base-restore-vm-types';
import { RestoreHyperVFormModel } from 'wizards/models/restoreHyperV/restore-hyper-v-form-model';
import { RestoreVMWareFormModel } from 'wizards/models/restoreVMWare/restore-vm-ware-form-model';

export class BaseForRestoreVMHelper extends BaseForStepsHelper {
  public static restoreVMModel: RestoreVMFormModel;

  protected static setSpecificStepsData(newPlan: any, settings: WizardHelpersSettings): void {}

  public static restoreVMModelFromPlan(plan, settings: WizardHelpersSettings = this.DefaultSettings): RestoreVMFormModel {
    this.restoreVMModel =
      settings.planType === PlanTypes.RestoreVMware || settings.planType === PlanTypes.RestoreVMwareToCustom
        ? new RestoreVMWareFormModel(settings.isNBF)
        : new RestoreHyperVFormModel(settings.isNBF);
    const newPlan = plan && (plan.plan || plan.Plan);

    if (newPlan) {
      this.setThisValues(plan, settings);
      this.setStorageType(settings.mode, newPlan.HybridID, newPlan.ConnectionID);

      const name =
        settings.mode === PlanMode.create || !newPlan.Name
          ? SupportMethodsForStepsFromPlan.generatePlanName(settings.compName, this.planType, this.timeZoneOffset)
          : newPlan.Name;
      this.restoreVMModel.planNameStep = RestoreStepsDataFromPlanHelper.updatePlanNameStep(name, newPlan.DeletePlan);
      this.restoreVMModel.whereBackupStep = StepsDataFromPlanHelper.updateWhereBackup(
        newPlan.IsHybridBackup,
        newPlan.HybridID,
        newPlan.ConnectionID
      );
      this.restoreVMModel.Storages = this.storages;
      this.restoreVMModel.computerToRestoreStep.computerName = newPlan.RestoreSourcePrefix || '';
      const { backupPlanName, restorePoint } = this.getBackupNameAndPoint(newPlan);
      this.restoreVMModel.backupToRestoreStep = RestoreStepsDataFromPlanHelper.updateBackupToRestore(
        newPlan,
        this.planType,
        backupPlanName,
        settings.isUnix
      );
      this.restoreVMModel.restorePointStep = RestoreStepsDataFromPlanHelper.updateRestorePoint(
        newPlan,
        true,
        restorePoint,
        settings.timeZoneOffset,
        settings.isUnix
      );
      this.restoreVMModel.restoreSourceStep = RestoreStepsDataFromPlanHelper.updateVMSource(
        newPlan,
        this.isUnix,
        this.isCreate,
        this.planType
      );
      this.restoreVMModel.typeDataStep = RestoreStepsDataFromPlanHelper.updateTypeDataStep(newPlan, this.isCreate, this.planType);
      this.restoreVMModel.restoreDisksStep = RestoreStepsDataFromPlanHelper.updateVMRestoreDisks(
        newPlan,
        this.restoreVMModel.restoreSourceStep.folders,
        this.isUnix
      );
      this.restoreVMModel.destinationStep = RestoreStepsDataFromPlanHelper.updateVMDestinationStep(newPlan, this.planType, this.isUnix);
      this.restoreVMModel.encryptionOptionsStep = RestoreStepsDataFromPlanHelper.updateEncryptionOptionsStep(
        newPlan,
        settings.mode === PlanMode.create,
        settings.isNBF
      );

      this.setSpecificStepsData(newPlan, settings);

      this.restoreVMModel.scheduleStep = StepsDataFromPlanHelper.updateSchedule(
        newPlan,
        plan.OverdueAfterSuccess,
        this.isCreate,
        this.isUnix,
        true
      );
      this.restoreVMModel.prePostActionsStep = StepsDataFromPlanHelper.updatePrePostActions(newPlan, true);
      this.restoreVMModel.notificationStep = StepsDataFromPlanHelper.updateNotification(
        newPlan.Notification,
        newPlan.WindowsEventLogNotification
      );
    }

    return this.restoreVMModel;
  }
}
